export default "__VITE_ASSET__b3ac5c7c__"